//@import dependencies
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux';
import { external_api } from 'app_config/globals';
//@end

// @import components
import IconComponent from 'app_components/commons/icons'
// @end

//@import service
import AuthService from 'app_services/secure/auth/authService'
import UserService from 'app_services/user/userService'
import {routingService} from 'app_services/routingService'
import { CSSProperties } from 'react';
//@end

// @import hooks
// @end

// @import actions
import { expand } from 'app_events/app/actions';
// @end

// @INFO Import Styles
import './../headerCommon.scss'
import { CgMenuRound } from 'react-icons/cg';
import LoginMoodle from 'app_components/modules/LoginMoodle/LoginMoodle';

// @ADD Component types
interface IHeaderCommonLayoutProps {
  style?: CSSProperties
  className?: string
}

const HeaderCommonLayout: React.FC<IHeaderCommonLayoutProps> = (props) => {

  const auth = useSelector((state: any) => state.auth ? state.auth : null)
  const dispatch = useDispatch()

  const authService: AuthService = new AuthService()
  const userService = new UserService()

  const onHandleLogout = () => {
    authService.logout()
  }

  const { t } = useTranslation()

  const changeSidebarStatus = () => {
    dispatch(expand(true))
  }

  return(
    <div className={`app-header ${props.className}`} style={props.style} >
      <div
        className="menu-button"
        onClick={changeSidebarStatus}
      >
        <CgMenuRound
          color='white'
          fontSize={32}
        />
      </div>
      <div className="empty"></div>
      <div className="actions" id="buttons_container">
        {userService.can('config:go_to_campus', 'global_permissions') && (
          <div className="go-to-campus" id="go_to_campus">
            <Link to={routingService.getPublicPath()}>
              <button className="btn btn-campus">
                {t('modules.header.private.go_to_campus')}&nbsp;&nbsp;
                <IconComponent
                  svg={'Home'}
                  width="1.3rem"
                  // fontawesome={{
                  //   icon: 'fas fa-home'
                  // }}
                />
              </button>
            </Link>
          </div>
        )}
        {
          (
            userService.can('config:go_to_moodle', 'global_permissions') &&
            external_api?.moodle?.url &&
            (auth?.user?.data?.moodle?.username && auth?.user?.data?.moodle?.password)
          ) &&
          (
          <div className="go-to-moodle" id="go_to_moodle">
            <LoginMoodle targetBlank>
              <button className="btn btn-moodle" type="button">
                {t('modules.header.private.go_to_moodle')}
              </button>
            </LoginMoodle>
          </div>
        )}
        <div className="logout" onClick={onHandleLogout}>
          <span>{t('modules.header.private.logout.title')}</span>
        </div>
      </div>
    </div>
  )
}

export default HeaderCommonLayout

